import { Box, FormControlLabel, FormGroup, Grid, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../../components/common/FormikControl";
import { addRole, moduleList, selectAllModulesList, selectBmrRolesLoading, selectRolesModule, selectAllRoles, roleRelatedModulesList, roleUpdate } from "../../../../slices/roles";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import IosSwitch from "../../../../components/styled/Switch";
import { useNavigate, useParams } from "react-router";
import SkeletonLoader from "../../../../../utilites/SkeltonLoader";
const formOptions = [
    {
        label: 'Title',
        type: 'text',
        name: 'title',
        required: true,
        placeholder: 'Enter role title'
    },
    {
        label: 'Description',
        type: 'textarea',
        name: 'description',
        required: true,
        placeholder: 'Enter role description'
    }
]

const validationSchema = Yup.object().shape({
    description: Yup.string().typeError("Must be a string").required(" Description  is required"),
    title: Yup.string().typeError("Must be a string").required(" Title  is required"),
    module_ids: Yup.array()
        .of(Yup.number().required('Modules is required')) // Validate each item as a number
        .min(1, 'At least one modules is required'),
})

const AddRoleForm = () => {
    const isLoading = useSelector(selectBmrRolesLoading)
    const allModulesList = useSelector(selectAllModulesList)
    const allRoles = useSelector(selectAllRoles)
    const rolesModule = useSelector(selectRolesModule)
    const navigate = useNavigate()
    const { rowId } = useParams()
    const dispatch = useDispatch()
    const editModule = rowId ? allRoles?.find(role => role.id == rowId) : undefined
    const initialValues = {
        title: editModule?.title ?? "",
        description: editModule?.description ?? "",
        module_ids: !rolesModule.length ? [] : rolesModule,
    }

    useEffect(() => {
        if (!allModulesList?.length) {
            fetchModulesList()
        }
        if (rowId) {
            modulePermission()
        }
    }, [])

    const modulePermission = async () => {
        await dispatch(roleRelatedModulesList(rowId))
    }



    const fetchModulesList = async () => {
        await dispatch(moduleList())
    }

    const handleSubmit = async (values) => {
        if (rowId) {
            await dispatch(roleUpdate({ data: values, rowId }))
        } else {
            await dispatch(addRole(values))
        }
        navigate(`/bmr/roles-management`)
    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: handleSubmit
    })

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {isLoading
                        ? <SkeletonLoader rowCount={3} isTable={false} width="100%" height={60} className={"ml-3 mb-3 rounded-md"} />
                        : formOptions.map((props, key) => (
                            <Grid key={key} item xs={12}>
                                <FormikControl formik={formik} {...props} />
                            </Grid>
                        ))}
                </Grid>
                <Box className="border border-gray-200 p-3 rounded-md">
                    <Box className="flex justify-content-between align-items-center">
                        <Typography variant="h5">Modules Details</Typography>
                        {isLoading
                            ? <SkeletonLoader rowCount={1} isTable={false} width="10%" height={40} className={"ml-3 mb-3 rounded-md"} />
                            : <FormGroup>
                                <FormControlLabel
                                    control={<IosSwitch defaultChecked={formik.values.module_ids.length === allModulesList.length} />}
                                    onChange={(event) => {
                                        const { checked } = event.target;
                                        formik.setFieldValue(
                                            'module_ids',
                                            checked
                                                ? allModulesList.map(module => module.id)
                                                : []
                                        );
                                    }}
                                />
                            </FormGroup>}
                    </Box>
                    <Grid container spacing={2} className="p-3 m-3">
                        {isLoading
                            ? <SkeletonLoader rowCount={18} isTable={false} width="10%" height={40} className={"ml-3 mb-3 rounded-md"} />
                            : <FormikControl
                                formik={formik}
                                name="module_ids"
                                type="switch"
                                options={allModulesList.map(module => { return { value: module.id, label: module.name } })}
                            />}
                    </Grid>
                </Box>
                <Grid container spacing={2} className="mt-1 text-center">
                    <Grid item xs={12}>
                        <LoadingButton loading={isLoading} type="submit" variant="contained">{rowId ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AddRoleForm;